import { AbstractEvent as n } from "./ghl-ui.es329.js";
class e extends n {
  constructor(t) {
    super(t), this.data = t;
  }
  get source() {
    return this.data.source;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get sourceContainer() {
    return this.data.sourceContainer;
  }
  get sensorEvent() {
    return this.data.sensorEvent;
  }
  get dragEvent() {
    return this.data.dragEvent;
  }
  get originalEvent() {
    return this.sensorEvent ? this.sensorEvent.originalEvent : null;
  }
}
class i extends e {
}
i.type = "mirror:create";
class o extends e {
  get mirror() {
    return this.data.mirror;
  }
}
o.type = "mirror:created";
class d extends e {
  get mirror() {
    return this.data.mirror;
  }
}
d.type = "mirror:attached";
class s extends e {
  get mirror() {
    return this.data.mirror;
  }
  get passedThreshX() {
    return this.data.passedThreshX;
  }
  get passedThreshY() {
    return this.data.passedThreshY;
  }
}
s.type = "mirror:move";
s.cancelable = !0;
class h extends e {
  get mirror() {
    return this.data.mirror;
  }
  get passedThreshX() {
    return this.data.passedThreshX;
  }
  get passedThreshY() {
    return this.data.passedThreshY;
  }
}
h.type = "mirror:moved";
class a extends e {
  get mirror() {
    return this.data.mirror;
  }
}
a.type = "mirror:destroy";
a.cancelable = !0;
export {
  d as MirrorAttachedEvent,
  i as MirrorCreateEvent,
  o as MirrorCreatedEvent,
  a as MirrorDestroyEvent,
  e as MirrorEvent,
  s as MirrorMoveEvent,
  h as MirrorMovedEvent
};
